module.exports = __webpack_public_path__ + "img/nav-right-expand-search-chevy.4bcecbdd.png";